import useIntl from '@/utils/intl'
import { Divider } from '@mui/material'
import { Link } from 'react-scroll'
import React, { FunctionComponent } from 'react'
import Image from 'next/image'
import { IMG_URL } from '@/utils/constants'

interface Menus {
  name: string
  to: string
  id: string
}

const HomeBottomNav: FunctionComponent = () => {
  const { translate } = useIntl()

  const menus: Menus[] = [
    {
      name: translate('homeNav.offers'),
      to: 'specialOffers',
      id: 'navigation.offers'
    },
    {
      name: translate('homeNav.shop'),
      to: 'handsets',
      id: 'navigation.shop'
    },
    {
      name: translate('home.help'),
      to: 'help',
      id: 'navigation.help'
    },
    {
      name: translate('home.development'),
      to: 'sdg',
      id: 'navigation.development'
    },
    {
      name: translate('homeNav.apps'),
      to: 'apps',
      id: 'navigation.apps'
    }
  ]
  return (
    <div className='hidden lg:flex mx-auto w-fit my-6 justify-center fixed bottom-2 left-1/2 translate-x-[-50%] z-10'>
      <div className='p-4 rounded-xl bg-secondaryAdditional border border-white/25'>
        <ul className='flex items-center justify-center gap-4'>
          {menus.map((item: Menus, i: number) => (
            <li id={item.id} key={i} className='truncate cursor-pointer hover:bg-appBar2 rounded-lg text-textAdditional font-semibold text-sm h-10 flex items-center justify-center text-center'><Link activeClass='cursor-pointer bg-appBar2 rounded-lg text-textAdditional text-center h-10 flex items-center justify-center text-center' spy smooth to={item.to}><p className='px-4'>{item.name}</p></Link></li>
          ))}
          <Divider className='bg-appBar2' orientation='vertical' flexItem />
          <li className='px-4 cursor-pointer rounded-lg text-[#8F8F8F] hover:bg-appBar2'>
            <Link spy smooth to='top'>
              <div className='w-10 h-10 border rounded-full flex justify-center items-center'>
                <Image draggable={false} width={20} height={20} src={IMG_URL + '/uploads/icons/chevrons-up.svg'} alt='right' />
              </div>
            </Link>
          </li>
        </ul>
      </div>
    </div>

  )
}
export default HomeBottomNav
